//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				padding: `0 ${minimumMarginX}rem`,
				marginTop: mt ? '3rem' : 'unset',
			};
		},
		rowContainerStyle: ({isOdd} = false) => {
			let bgColor = isOdd ? 'rgba(37, 92, 153, 0.1)' : 'unset';
			return {
				display: `flex`,
				width: '100%',
				height: 'auto',
				padding: '1rem',
				backgroundColor: bgColor,
			};
		},
		mobRowContainerStyle: ({isOdd} = false) => {
			let bgColor = isOdd ? 'rgba(37, 92, 153, 0.1)' : 'unset';
			return {
				display: `flex`,
				flexWrap: 'wrap',
				width: '100%',
				height: 'auto',
				padding: '0 1rem 1rem 1rem',
				backgroundColor: bgColor,
			};
		},
		titleStyle: () => {
			return {
				width: '100%',
				color: 'black',
				width: '100%',
				textAlign: 'center',
			};
		},
		textStyle: ({isHeader}) => {
			let fontWeight = isHeader ? 700 : 400;
			return {
				fontWeight: fontWeight,
			};
		},
		textClasses: ({entrys}) => {
			let colAmount = 12 / (entrys || 1);
			let classes = `col-${colAmount} pe-2`;
			return classes;
		},
		mobTextStyle: ({isHeader} = {}) => {
			let fontWeight = isHeader ? 700 : 400;
			return {
				marginTop: `1rem`,
				fontWeight: fontWeight,
			};
		},
		mobTextClasses: () => {
			let classes = `col-6`;
			return classes;
		},
	};
}

export default Styles;
